import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// #region Component Styles
const Container = styled.div`
  background-color: var(--dui-color-white-500);
  border-radius: var(--dui-size-radius-md);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 12px 0 rgba(0, 0, 0, 0.1),
    0 0 1px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: var(--dui-size-space-10x) calc(var(--dui-size-space-3x) * 5)
    calc(var(--dui-size-space-3x) * 4) var(--dui-size-space-10x);
`;
// #endregion

const Card = ({ children, className }) => (
  <Container className={className}>{children}</Container>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  /** Class to the root element */
  className: PropTypes.string,
};

export default Card;
